import React from 'react';
import { resolveUploadUrl } from '../utils/uploadUrl';

interface ImageBindingVisualItem {
  name: string;
  value: string;
  display: string;
  hit: boolean;
  predicted?: boolean;
  image?: string;
  x?: number;
  y?: number;
  width?: number;
  height?: number;
}

interface ImageBindingSceneCardProps {
  items: ImageBindingVisualItem[];
  hitEffectMode?: 'normal' | 'legacy' | string;
  backgroundImage?: string;
  sceneWidth?: number;
  sceneHeight?: number;
  period?: string;
  suc?: boolean | null;
  openTitle?: string;
}

function toPercent(value: number, total: number) {
  return `${(value / total) * 100}%`;
}

function toGridStartPercent(value: number, total: number) {
  const normalized = Math.max(1, value);
  return `${((normalized - 1) / total) * 100}%`;
}

function ImageBindingSceneCard({
  items,
  hitEffectMode,
  backgroundImage,
  sceneWidth = 1180,
  sceneHeight = 900,
  period,
  suc,
  openTitle,
}: ImageBindingSceneCardProps) {
  const hasResult = suc !== null && suc !== undefined;
  const resultText = hasResult ? (openTitle || (suc ? '准' : '错')) : '未开奖';
  const useLegacyImageHitFx = hitEffectMode === 'legacy';

  return (
    <div className="image-binding-scene visual-scene">
      <div
        className="image-binding-stage"
        style={{ paddingTop: `${(sceneHeight / sceneWidth) * 100}%` }}
      >
        {backgroundImage ? (
          <img className="image-binding-bg" src={resolveUploadUrl(backgroundImage)} alt="" />
        ) : (
          <div className="image-binding-bg image-binding-bg-placeholder">请上传背景图</div>
        )}

        <div className="image-binding-overlay" />

        {period ? <div className="image-binding-period">第 {period}</div> : null}

        <div className={`image-binding-result ${hasResult ? (suc ? 'is-hit' : 'is-miss') : 'is-pending'}`}>
          {resultText}
        </div>

        {items.map((item, index) => {
          const width = Math.max(1, item.width ?? 1);
          const height = Math.max(1, item.height ?? 1);
          const x = Math.max(1, item.x ?? 1);
          const y = Math.max(1, item.y ?? 1);
          const isHit = hasResult && !!item.hit;
          const displayText = item.display && item.display !== item.value ? item.display : item.name;

          return (
            <div
              key={`${item.name}-${index}`}
              className={`image-binding-item ${isHit ? 'is-hit' : 'is-normal'}`}
              style={{
                left: toGridStartPercent(x, sceneWidth),
                top: toGridStartPercent(y, sceneHeight),
                width: toPercent(width, sceneWidth),
                height: toPercent(height, sceneHeight),
              }}
            >
              <div className="image-binding-item-inner">
                <div className={`image-binding-item-media-shell${isHit ? ' zt-hit zt-hit-current image-binding-item-media-shell-hit' : ''}${isHit && useLegacyImageHitFx ? ' image-binding-item-media-shell-legacy' : ''}`}>
                  {isHit && useLegacyImageHitFx ? (
                    <div className="image-binding-item-effects" aria-hidden="true">
                      <span className="image-binding-item-orbit image-binding-item-orbit-a" />
                      <span className="image-binding-item-orbit image-binding-item-orbit-b" />
                      <span className="image-binding-item-flare image-binding-item-flare-a" />
                      <span className="image-binding-item-flare image-binding-item-flare-b" />
                      <span className="image-binding-item-particle image-binding-item-particle-a" />
                      <span className="image-binding-item-particle image-binding-item-particle-b" />
                      <span className="image-binding-item-particle image-binding-item-particle-c" />
                    </div>
                  ) : null}
                  <div className="image-binding-item-media">
                    {item.image ? (
                      <img
                        className="image-binding-item-image"
                        src={resolveUploadUrl(item.image)}
                        alt={displayText}
                      />
                    ) : (
                      <div
                        className="image-binding-item-placeholder"
                      >
                        {displayText}
                      </div>
                    )}
                  </div>
                </div>
                <div className="image-binding-item-nameplate">{displayText}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ImageBindingSceneCard;
